if (!customElements.get('swiper-slider')) {
  customElements.define('swiper-slider', class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.state = {
        index: 0
      }

      this.elements = {
        viewer: this.querySelector('[id^="slider"]'),
        fullscreenViewer: this.querySelector('[id^="fullscreen-slider"]'),
        slides: document.querySelectorAll('.swiper-slide'),
        openButton: this.querySelector('.swiper-button-open-modal'),
        closeButton: this.querySelector('.swiper-button-close-modal')
      }

      if (this.elements.slides.length > 1) {
        this.swiper = new Swiper(this.elements.viewer, {
          // Optional parameters
          speed: 800,
          height: 800,
          spaceBetween: 15,
          breakpoints: {
            // when window width is >= 990px
            990: {
              spaceBetween: 30
            }
          },
          loop: true,
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'custom',
            renderCustom: function(swiper, current, total) {
              return `${current} of ${total}`;
            }
          }
        }); 

        this.fullscreenSwiper = new Swiper(this.elements.fullscreenViewer, {
          // Optional parameters
          speed: 800,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'custom',
            renderCustom: function(swiper, current, total) {
              return `${current} of ${total}`;
            }
          }
        });
  
        this.eventHandlers();
      }
    }

    eventHandlers() {
      this.elements.openButton.addEventListener('click', this.openFullscreen.bind(this));
      this.elements.closeButton.addEventListener('click', this.closeFullscreen.bind(this));

      this.swiper.on('slideChange', (swiper) => {
        this.state.index = swiper.activeIndex;
      });

      this.fullscreenSwiper.on('slideChange', (swiper) => {
        this.state.index = swiper.activeIndex;
      });
    }

    openFullscreen() {
      this.elements.fullscreenViewer.classList.add('is-open');

      this.fullscreenSwiper.slideTo(this.setAttribute.index, 0);
    }

    closeFullscreen() {
      this.elements.fullscreenViewer.classList.remove('is-open');

      this.swiper.slideTo(this.setAttribute.index, 0);
    }
  });
}
